import { Grid, makeStyles } from "@material-ui/core";
import { observer } from "mobx-react";
import { CompsCardView } from "./compsCardView";
import { CompPagination } from "./compPagination";
import { useStore } from "@roc/client-portal-shared/hooks";
import { CompsListView } from "./compsListView";
import { ComparablesFilters } from "./filters/comparablesFilters";
import PropertiesMap from "./map/propertiesMap";
import AddComparableSearchModal from "./addComparableSearchModal";
import { useState } from "react";
import PropertyViewModal from "./propertyViewModal";
import { ComparablesSectionHeader } from "./comparablesSectionHeader";

const useStyles = makeStyles((theme) => ({
  cardsContainer: {
    maxHeight: '850px',
    overflow: 'auto',
    overflowX: 'hidden',
  }
}));

export const ComparablesSection = observer(() => {
  const { compToolStoreV2: compToolStore } = useStore();
  const [openAddComparableSearchModal, setOpenAddComparableSearchModal] = useState(false)
  const [openPropertyViewModal, setOpenPropertyViewModal] = useState(false)

  const classes = useStyles();
  const mapExtended = compToolStore.propertiesMapExtended || !compToolStore.showCardView;

  let mapHeight = "auto";
  if (compToolStore.propertiesMapExtended) {
    mapHeight = "800px";
  } else if (!compToolStore.showCardView) {
    mapHeight = "500px";
  }

  const openDialog = () => {
    setOpenAddComparableSearchModal(true)
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ComparablesFilters />
        </Grid>
        <Grid item xs={12}>
          <ComparablesSectionHeader onAddComparableClick={openDialog} />
        </Grid>
        <Grid item xs={12} lg={mapExtended ? 12 : 6} style={{ height: mapHeight, minHeight: "500px" }}>
          <PropertiesMap />
        </Grid>
        {compToolStore.showCardView && !compToolStore.propertiesMapExtended &&
          (
            <Grid item xs={12} lg={6} className={classes.cardsContainer}>
              <CompsCardView />
            </Grid>
          )}
        {!compToolStore.showCardView &&
          (
            <Grid item xs={12}>
              <CompsListView />
            </Grid>
          )
        }
        <Grid item xs={12} lg={12}>
          <CompPagination />
        </Grid>
      </Grid >
      <AddComparableSearchModal
        open={openAddComparableSearchModal}
        onClose={() => setOpenAddComparableSearchModal(false)}
        setOpenPropertyViewModal={setOpenPropertyViewModal} />
      <PropertyViewModal
        open={openPropertyViewModal}
        property={compToolStore.addressPropertyData}
        onClose={() => setOpenPropertyViewModal(false)} />
    </>
  )
});